import { useState, useEffect } from "react";
import { useSearchParams } from "react-router";
import { Tabs } from "antd";

import Discrepancies from "./Discrepancies";
import Rules from "./Rules";
import InfoTooltip from "@/components/UI/InfoTooltip";

/* eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO(eslint-baseline): address @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */
export default function DataDiscrepancies({ data }: { data: any[] }) {
  const [searchParams] = useSearchParams();
  const openIssueId = searchParams.get("openIssue");
  const subjectParam = searchParams.get("subject") ?? undefined;
  const [activeTab, setActiveTab] = useState("discrepanices");

  useEffect(() => {
    if (openIssueId || subjectParam) {
      setActiveTab("discrepanices");
    }
  }, [openIssueId, subjectParam]);

  const items = [
    {
      key: "discrepanices",
      label: "Discrepancies",
      children: (
        <Discrepancies
          openIssueId={openIssueId}
          singleSubjectId={subjectParam}
        />
      ),
    },
    {
      key: "rules",
      label: "Rules",
      children: <Rules />,
    },
  ];
  return (
    <div className="w-full px-[18px] pt-[30px]">
      <div className="flex items-center gap-2 flex-row">
        <h1 className="text-[18px] font-bold mb-[24px]">
          Data: Discrepancies{" "}
          <InfoTooltip title="Vivo automatically identifies and tracks data discrepancies in the trial data across data sources." />
        </h1>
      </div>
      <Tabs items={items} activeKey={activeTab} onChange={setActiveTab} />
    </div>
  );
}
